import { Button, CircularProgress, styled } from '@material-ui/core';
import React from 'react';
import { PropTypes } from 'prop-types';
export const ButtonCircularProgress = styled(({ ...props }) => <CircularProgress {...props} />)({
    height: '15px !important',
    width: '15px !important',
    color: (props) => (props.secondary ? '#1b90fa' : 'white')
});
const CustomizedSubmitButton = styled(({ ...props }) => <Button {...props} />)((props) => ({
    minWidth: props.width ? props.width + 'px' : '94.5px',
    height: props.height || '40px',
    width: props.fullWith && '100%',
    color: props.secondary ? '#1b90fa' : undefined,
    border: props.secondary ? 'solid 2px #1b90fa' : undefined,
    backgroundColor: props.secondary ? 'white' : undefined,
    boxShadow: 'unset',
    marginRight: props.mr ? props.mr + 'px' : '14px',
    marginTop: props.mt || undefined,
    '& .hidden': {
        visibility: 'hidden',
        height: '0',
        overflow: 'hidden'
    },
    '& .circularContainer': {
        display: 'flex',
        position: 'absolute',
        left: '0',
        right: '0',
        justifyContent: 'center'
    },
    '&:hover': {
        backgroundColor: props.secondary ? 'white' : undefined,
        color: props.secondary ? '#1b90fa' : undefined,
        boxShadow:
            '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%) !important'
    },
    [props.theme.breakpoints.down(1025)]: props.isSearch && {
        backgroundColor: '#fff',
        color: '#1b90fa',
        border: 'solid 1.5px #1b90fa',
        boxShadow: 'none !important',
        marginRight: '0',
        marginTop: '24px'
    },
    '&:disabled': {
        border: 'none',
        cursor: 'not-allowed',
        pointerEvents: 'all !important',
        opacity: '1',
        color: '#fff !important'
    },
    '&[disabled]:hover': {
        boxShadow: 'none !important'
    }
}));

export default function SubmitButton({
    secondary,
    disableSubmit,
    isSubmitting,
    submitText,
    handleClick,
    isSearch,
    fullWith,
    mr,
    mt,
    children,
    isButton,
    width,
    height,
    ...props
}) {
    return (
        <CustomizedSubmitButton
            isSearch={isSearch}
            fullWith={fullWith}
            mr={mr}
            mt={mt}
            secondary={secondary}
            type={secondary ? 'reset' : disableSubmit ? 'button' : 'submit'}
            variant={secondary ? 'outlined' : 'contained'}
            disabled={isSubmitting}
            isSubmitting={isSubmitting}
            width={width}
            height={height}
            {...props}
            onClick={() => (secondary || disableSubmit || isButton ? handleClick() : {})}
        >
            {children || (
                <>
                    <span className={isSubmitting ? 'hidden' : ''}>
                        {submitText ? submitText : 'submit'}{' '}
                    </span>
                    <div className="circularContainer">
                        {isSubmitting && <ButtonCircularProgress />}
                    </div>
                </>
            )}
        </CustomizedSubmitButton>
    );
}
SubmitButton.propTypes = {
    isSubmitting: PropTypes.bool,
    submitText: PropTypes.string,
    secondary: PropTypes.bool,
    handleClick: PropTypes.func,
    disableSubmit: PropTypes.bool,
    isSearch: PropTypes.bool,
    fullWith: PropTypes.bool,
    mr: PropTypes.string,
    mt: PropTypes.string,
    children: PropTypes.any,
    isButton: PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string
};
